var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6673 2.35236V7.35236M19.6673 7.35236H14.6673M19.6673 7.35236L15.8007 3.71902C14.905 2.82295 13.797 2.16836 12.58 1.81634C11.3629 1.46431 10.0766 1.42632 8.84089 1.70591C7.60521 1.9855 6.46048 2.57355 5.51354 3.41521C4.56659 4.25686 3.84829 5.32468 3.42565 6.51902M1.33398 15.6857V10.6857M1.33398 10.6857H6.33398M1.33398 10.6857L5.20065 14.319C6.09627 15.2151 7.20429 15.8697 8.42132 16.2217C9.63835 16.5737 10.9247 16.6117 12.1604 16.3321C13.3961 16.0526 14.5408 15.4645 15.4878 14.6228C16.4347 13.7812 17.153 12.7134 17.5756 11.519",
    stroke: "#00535C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.294a566a2693785ed87cff1a56c51147.svg";
export { ForwardRef as ReactComponent };